module.exports = __webpack_public_path__ + "img/lg_ring_r_c_null_null.b7f0208d.png";